import ForgotPassword from './ForgotPassword'
export { ForgotPassword }
export default ForgotPassword
